<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Clientes</h4>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th></th>
                                <!--
                              <th>Id Cliente</th>
                              -->
                                <th>RFC</th>
                                <th>Nombre/RFC</th>
                                <th>Atendido por :</th>
                                <th>Fecha de registro</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cliente of clientesArray" style="text-align: center" (click)="clienteSeleccionado(cliente)">
                                <td>{{ cliente.id }}</td>
                                <!--
                              <td>{{ cliente.idCliente }}</td>
                              -->
                                <td>{{ cliente.rfc }}</td>
                                <td *ngIf="cliente.razonSocial===''; else traer">{{ cliente.nombre }} {{ cliente.paterno }} {{ cliente.materno }}</td>
                                <ng-template #traer>
                                    <td>{{cliente.razonSocial}}</td>
                                </ng-template>

                                <td>{{ cliente.creadoPor }}</td>
                                <td>{{ cliente.fechaCreacion }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/clientes-obra/clientes-obra.component.html